module.exports = __webpack_public_path__ + "static/header2-5dcf46a6bc66403f08a73f5f7ed4bcdd.jpg";